import { useEffect } from 'react';
import '../participation.css';

interface InfoModalProps {
  onClose: () => void;
}

export function InfoModal({ onClose }: InfoModalProps): JSX.Element {
  useEffect(() => {
    function onKey(e: KeyboardEvent): void { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const section = (title: string, content: string): JSX.Element => (
    <div style={{ marginBottom: 20 }}>
      <h3 style={{ margin: '0 0 6px', fontSize: 14.5, fontWeight: 700, color: '#1a1a2e' }}>{title}</h3>
      <p style={{ margin: 0, fontSize: 13.5, color: '#4b5563', lineHeight: 1.7 }}>{content}</p>
    </div>
  );

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Sobre la consulta"
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.35)', zIndex: 2000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20, backdropFilter: 'blur(3px)',
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#fff', borderRadius: 18, padding: '32px 36px',
        maxWidth: 560, width: '100%', maxHeight: '88vh', overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 28 }}>
          <div>
            <p style={{ margin: '0 0 4px', fontSize: 11.5, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              San Cristóbal de las Casas
            </p>
            <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#1a1a2e' }}>
              Sobre esta consulta
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar información"
            style={{ width: 34, height: 34, borderRadius: '50%', border: '1.5px solid #e8e8e8', background: '#fff', cursor: 'pointer', fontSize: 15, color: '#9ca3af', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            ✕
          </button>
        </div>

        {section(
          '¿Qué es esta consulta?',
          'Esta consulta busca recoger aportes ciudadanos sobre la ciudad, sus zonas y sus calles o lugares específicos. La información será utilizada como insumo para el diagnóstico urbano participativo de San Cristóbal de las Casas.',
        )}
        {section(
          '¿Para qué se usarán los aportes?',
          'Los aportes serán revisados por el equipo técnico y podrán contribuir a identificar problemáticas, oportunidades y prioridades territoriales para el diagnóstico urbano participativo de San Cristóbal de las Casas.',
        )}
        {section(
          '¿Quién puede participar?',
          'Cualquier persona que viva, trabaje o transite por San Cristóbal de las Casas puede participar. No se requiere registro ni cuenta.',
        )}
        {section(
          '¿Los aportes son anónimos?',
          'Sí. Puedes participar de forma completamente anónima. No almacenamos tu nombre ni información personal a menos que elijas dejar tus datos de contacto de manera voluntaria.',
        )}
        {section(
          '¿Qué pasa si dejo mis datos de contacto?',
          'Si decides dejar tu nombre, correo o teléfono, esos datos se guardan de forma segura y solo serán utilizados si el equipo necesita ampliar información sobre tu aporte específico. No se comparten con terceros ni se usan para otros fines.',
        )}

        <div style={{ marginTop: 28, paddingTop: 20, borderTop: '1px solid #f0f0f0' }}>
          <p style={{ margin: 0, fontSize: 12, color: '#94a3b8', lineHeight: 1.6 }}>
            Esta consulta es impulsada por el Municipio de San Cristóbal de las Casas con apoyo técnico de Wayline. Para dudas o comentarios sobre la consulta, comunícate con el equipo del proyecto.
          </p>
        </div>

        <button
          type="button"
          onClick={onClose}
          style={{ marginTop: 20, width: '100%', padding: '12px', borderRadius: 12, border: 'none', background: '#1a1a2e', color: '#fff', fontSize: 14.5, fontWeight: 600, cursor: 'pointer' }}
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
